import Auth2 from '../shared/Auth2'
import { noLog as log } from '../shared/Utils'
import {
  getContainingUrlFromActiveTab,
  getExtensionVersion
} from '@mote/helpers/extension'

import {
  MAXIMUM_TRACKING_BUFFER_LENGTH,
  TRACKING_BUFFER_TIMEOUT,
  SAMPLEABLE_EVENT_WHITELIST,
  SAMPLE_CHARS
} from '@mote/helpers/constants'
import { getApplicationName } from '../helpers/getApplicationName'
import { getApplicationView } from '../helpers/getApplicationView'
import { DiagnosticsLogger } from '@mote/helpers/diagnostics'
import { apiClient } from '@mote/api'

var _BUFFER = []

const logD = new DiagnosticsLogger('PluginAnalytics')

var _EXTENSION_VERSION = getExtensionVersion()
const ANALYTICS_PARAMS_BLACKLIST = [
  'accessToken',
  'userId',
  'imageURL',
  'quotaResetsAt',
  'productStates',
  'acquiredScopes',
  'goals',
  'isInstitutional'
]

function identify() {
  apiClient.post('s/identify/everything', {
    json: {
      ..._safeTraits(),
      userId: Auth2.getUserId()
    }
  })
  _flushBuffer()
}

function track(event, o, noURLContext) {
  if (SAMPLEABLE_EVENT_WHITELIST.includes(event)) {
    if (!Auth2.isLoggedIn()) {
      return
    }
    const firstCharacter = Auth2.getUserId()[0]

    if (!SAMPLE_CHARS.includes(firstCharacter)) {
      return
    }
  }

  if (!o) {
    o = {}
  }
  var oo = Object.assign({}, o)
  if (!noURLContext) {
    oo['application'] = getApplicationName()
  }
  oo['event'] = event

  if (_shouldBuffer()) {
    log('adding this event to the buffer: ', oo)
    _BUFFER.push([Date.now(), oo])
    setTimeout(() => _flushBuffer(), TRACKING_BUFFER_TIMEOUT)
  } else {
    _flushBuffer()
    _track_raw(oo)
  }
}

function _track_raw(o) {
  var oo = Object.assign({}, o)
  oo['userId'] = Auth2.getUserId()
  if (_EXTENSION_VERSION) {
    oo['extension_version'] = _EXTENSION_VERSION
  }
  if (!oo['application_view']) {
    oo['application_view'] = getApplicationView()
  }
  if (window.location?.protocol.includes('chrome-extension')) {
    getContainingUrlFromActiveTab().then(url => {
      if (!url) return

      oo['page_context'] = url

      const parsedUrl = new URL(url)

      oo['application_domain'] = parsedUrl?.hostname
      oo['application_domain_path_prefix'] = `${parsedUrl?.hostname}/${
        parsedUrl?.pathname.replace('/', '')?.split('/')?.[0]
      }`
    })
  } else {
    oo['page_context'] = window.location?.href

    oo['application_domain'] = window.location?.hostname
    oo['application_domain_path_prefix'] = `${window.location?.hostname}/${
      window.location?.pathname.replace('/', '')?.split('/')?.[0]
    }`
  }
  logD.info('[TRACKING.extension] ' + oo['event'], oo)
  apiClient.post('s/track/everything', { json: oo })
}

function _shouldBuffer() {
  if (Auth2.isLoggedIn()) {
    return false
  } else if (_BUFFER.length > MAXIMUM_TRACKING_BUFFER_LENGTH) {
    return false
  } else if (
    _BUFFER.length > 0 &&
    Date.now() - _BUFFER[0][0] > TRACKING_BUFFER_TIMEOUT
  ) {
    return false
  } else {
    return true
  }
}

function _flushBuffer() {
  while (_BUFFER.length > 0) {
    const arr = _BUFFER.shift()
    log('sending old event')
    _track_raw(arr[1])
  }
}

function _safeTraits() {
  var oo = Object.assign({}, Auth2.getCache())
  log('Building safe traits: ', oo)
  for (const key of ANALYTICS_PARAMS_BLACKLIST) {
    if (key in oo) {
      oo[key] = undefined
    }
  }
  oo['from_extension'] = '1'
  if (oo.primaryEmailAddress) {
    const email = oo.primaryEmailAddress
    oo.primaryEmailAddress = undefined
    oo['email'] = email
    const atSymbolIndex = email.indexOf('@')
    if (atSymbolIndex > 0 && email.length > atSymbolIndex + 1) {
      oo['email_domain'] = email
        .slice(atSymbolIndex + 1, email.length)
        .toLowerCase()
    }
  }
  if (
    oo.isMinor === true ||
    oo.isMinor === 'true' ||
    oo.isMinor === 'True' ||
    oo.isMinor === '1' ||
    oo.isMinor === 1
  ) {
    oo.isMinor = '1'
  } else {
    oo.isMinor = '0'
  }
  return _snake_case(oo)
}

function _snake_case(o) {
  log('Input object', o)
  for (var key of Object.keys(o)) {
    var value = o[key]
    var currentKey = key
    log('checking: ' + currentKey + ' with ' + value)
    while (true) {
      const found = currentKey.match(/^([a-z_]+)([A-Z][a-z]+)([A-Z][a-z]+)?/)
      if (!found) {
        if (currentKey === 'imageURL') {
          o[currentKey] = undefined
          o['image_URL'] = value
        } else if (currentKey === 'TZOffset') {
          o[currentKey] = undefined
          o['TZ_offset'] = value
        }
        break
      } else {
        o[currentKey] = undefined
        var camel = found[2]
        if (camel !== 'URL') {
          camel = camel.toLowerCase()
        }
        var suffix = found[3]
        if (!suffix) {
          suffix = ''
        }
        currentKey = found[1] + '_' + camel + suffix
        o[currentKey] = value
      }
    }
  }
  return o
}

export { identify, track }
